<template>
  <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link class="navbar-item" :to="{name:'home'}">
        <img src="../img/logo.svg" width="112" height="28" alt="I-CAN!" />
      </router-link>

      <a
        role="button"
        :class="`navbar-burger burger ${expandNav?'is-active':''}`"
        aria-label="menu"
        :aria-expanded="expandNav"
        data-target="Navbar"
        v-on:click="expandNav=!expandNav"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="Navbar" :class="`navbar-menu ${expandNav?'is-active':''}`">
      <div class="navbar-start">
        <router-link
          class="navbar-item"
          :to="{name: 'moduleList'}"
          v-if="$store.getters.authenticated"
        >Modules</router-link>
        <router-link
          class="navbar-item"
          :to="{name: 'schedule'}"
          v-if="$store.getters.authenticated"
        >My I-CAN! Schedule</router-link>
        <router-link class="navbar-item" :to="{name: 'about'}">About I-CAN!</router-link>
        <router-link class="navbar-item" :to="{name: 'contact'}">Contact us</router-link>
      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <router-link
              class="button is-info"
              :to="{name: 'login'}"
              v-if="!$store.getters.token"
            >Login</router-link>
            <a class="button is-danger" v-if="$store.getters.token" v-on:click="logout">Logout</a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return { expandNav: false };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "home" });
    }
  }
};
</script>